import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

const CountSpan = styled.span`
    font-weight: bold;
    font-size: 2rem;
`;

const CongestionSummary = ({ count, totalCount, label, time = false, sec }) => {
    return (
        <div className={'widget-item-nums'}>
            {!time ? (
                <div className={'col view'}>
                    <CountSpan>
                        {count}/{totalCount}
                    </CountSpan>
                    <span className={'font-weight-bold text-center'}>{label}</span>
                </div>
            ) : (
                <div className={'col view'}>
                    <div>
                        {sec >= 60 && <CountSpan>{moment(sec * 1000).format('m')}m</CountSpan>}
                        <CountSpan>{moment(sec * 1000).format('s')}s</CountSpan>
                    </div>
                    <span className={'font-weight-bold text-center'}>{label}</span>
                </div>
            )}
        </div>
    );
};

export default CongestionSummary;
